













import {ChartDataTemplate, FCConfTpl, WConfTpl, WidgetDefinition, WParamTpl} from "@/components/widgets/WidgetFather"
import {computed, defineComponent, reactive, ref, watch} from "@vue/composition-api"
import {buildQueryDownloadUrl, executeQuery} from "@/data/repos/query"
import {bus} from "@/main"
import {getAppraisalCaption, getLocationCaption} from "@/data/sources/appraisal"
import {extractAppraisalItem} from "@/data/repos/appraisal"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.TimeSeries(),
    widget: "AppraisalLifecycleCost",
    title: "Appraisal lifecycle cost",
    _description: "The Life cycle costs widget allows users to view the life cycle costs of SubElements over time.",
    params: {
      locationId: {...WParamTpl.locationId(), _order: 1},
      appraisalEntity: {...WParamTpl.Appraisal(), _order: 2},
    },
  }
}

function getChartConfig() {
  return reactive(FCConfTpl())
}

function getChartDataConfig() {
  return reactive({
      ...ChartDataTemplate(),
      caption: "Costs",
      theme: "micad",
      xAxisName: "Years",
      yAxisName: "Cost",
      showLabels: "1",
      animation: "1",
      Color: "#A3B8F5",
    },
  )
}

export default defineComponent({
  props: {
    config: Object,
  },
  components: {
    FusionChartWidget,
  },
  setup(props, context) {
    const errorMessage = ref("")
    context.emit("config-update", config())

    async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
      if (config) {
        chartDataConfig.subCaption =
            "Location: " + await getLocationCaption(config.params.locationId) + "<br>" +
            "Appraisal: " + getAppraisalCaption(config.params.appraisalEntity)
      }
    }

    function dataplotClickCallback(label: string, val: any) {
      const params = props.config && props.config.params
      showDrillDown(label, val, params)
    }

    async function dataFetcher(params: any): Promise<{ data: any[] | null }> {
      if (!params.appraisalEntity.value.survey || !params.appraisalEntity.value.survey.value) {
        errorMessage.value = "Please configure Survey"
        return {data: []}
      }
      errorMessage.value = ""
      const surveyId = params.appraisalEntity.value.survey.value
      const facetId = params.appraisalEntity.value.survey_facets.value
      const categoryId = params.appraisalEntity.value.facet_categories.value
      const elementId = params.appraisalEntity.value.category_elements.value
      const subelementId = params.appraisalEntity.value.element_subelements.value
      // console.debug('getAppraisalRisk:', surveyId, facetId, categoryId, elementId, subelementId)
      let queryName = subelementId ? "appraisal.costs.costs_subelement" :
        elementId ? "appraisal.costs.costs_element" :
          categoryId ? "appraisal.costs.costs_category" :
            facetId ? "appraisal.costs.costs_facet" :
              surveyId ? "appraisal.costs.costs_survey" : null
      if (queryName) {
        return {
          data: await executeQuery(
            "idr", queryName, {
              locationId: parseInt(params.locationId.value), surveyId, facetId, categoryId, elementId, subelementId,
            }, convert),
        }
      } else {
        return {data: []}
      }

      function convert(data: any[]): { label: string, value: string }[] {
        return data.map((v) => {
            return {label: String(v.costs_year), value: v.totalCosts}
          },
        )
      }
    }

    const downloadUrl = computed(() => {
      const params = props.config && props.config.params
      const item = extractAppraisalItem(params.appraisalEntity)
      if (!item) {
        return null
      }
      const queryName = item.subelementId ? "appraisal.costs.costsDrillDown_subelement" :
        item.elementId ? "appraisal.costs.costsDrillDown_element" :
          item.categoryId ? "appraisal.costs.costsDrillDown_category" :
            item.facetId ? "appraisal.costs.costsDrillDown_facet" :
              item.surveyId ? "appraisal.costs.costsDrillDown_survey" :
                null
      const args: any = item.subelementId ? {subelementId: item.subelementId} :
        item.elementId ? {elementId: item.elementId} :
          item.categoryId ? {categoryId: item.categoryId} :
            item.facetId ? {facetId: item.facetId} :
              item.surveyId ? {surveyId: item.surveyId} :
                {}
      args.locationId = parseInt(params.locationId.value)
      return queryName ? buildQueryDownloadUrl("idr", queryName, args) : null
    })

    return {dataFetcher, getChartDataConfig, dataplotClickCallback, configChangeCallback, downloadUrl, errorMessage}
  },
})

function showDrillDown(label: string, val: any, params: any) {
  bus.$emit("modalBoxCreate", {
    component: drillDown,
    componentArgs: {
      locationId: params.locationId.value,
      aprItem: extractAppraisalItem(params.appraisalEntity),
      year: parseInt(label),
    },
  })
}

const drillDown = () => ({
  component: import("@/components/widgets/appraisal/AppraisalLifecycleCostDrillDown.vue"),
  delay: 200,
  timeout: 3000,
})
